import PatientDirectoryTable from './PatientDirectoryTable'

export default PatientDirectoryTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/PatientDirectoryTable/index.js